import { cx } from '@linaria/core';
import { useRef, useId, useState } from 'react';
import { resets } from '@ui/css';
import { handle } from './atom.drag-handle.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const ARROW_KEY_MOVEMENT_PX = 20;
function DragHandle(props) {
  const buttonRef = useRef(null);
  const liveContainerRef = useRef(null);
  const liveContainerId = useId();
  const descriptionId = useId();
  const [isMoving, setIsMoving] = useState(false);
  const onKeyDown = evt => {
    const liveContainer = liveContainerRef.current;
    if (!liveContainer) {
      return;
    }
    if (!isMoving) {
      if (evt.key === "Enter" || evt.key === " ") {
        liveContainer.innerText = "Brik-områdets højde kan nu justeres. Brug op og ned piletasterne for at ændre højden. Tryk på Enter for at for at færdiggøre justeringen.";
        setIsMoving(true);
      }
      return;
    }
    switch (evt.key) {
      case "Enter":
      case " ":
        liveContainer.innerText = "Brik-områdets højde blev justeret.";
        setIsMoving(false);
        break;
      case "ArrowUp":
        evt.preventDefault();
        props.updatePosition(props.yPosition + ARROW_KEY_MOVEMENT_PX);
        break;
      case "ArrowDown":
        evt.preventDefault();
        props.updatePosition(props.yPosition - ARROW_KEY_MOVEMENT_PX);
        break;
    }
  };
  const preventScroll = evt => {
    evt.preventDefault();
  };
  const onBlur = () => {
    setIsMoving(false);
  };
  const onPointerDown = evt => {
    const button = buttonRef.current;
    if (!button || !evt.isPrimary) {
      return;
    }
    evt.preventDefault();
    setIsMoving(true);
    const initialElementPosition = props.yPosition;
    const initialPointerPosition = {
      x: evt.clientX,
      y: evt.clientY
    };
    const onPointerMove = evt => {
      const offsetY = evt.clientY - initialPointerPosition.y;
      props.updatePosition(initialElementPosition - offsetY);
    };
    const onEnd = () => {
      setIsMoving(false);
      window.removeEventListener("touchmove", preventScroll);
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", onEnd);
      window.removeEventListener("pointercancel", onEnd);
      window.removeEventListener("pointerleave", onEnd);
    };
    window.addEventListener("touchmove", preventScroll, {
      passive: false
    });
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onEnd);
    window.addEventListener("pointercancel", onEnd);
    window.addEventListener("pointerleave", onEnd);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("button", {
      ref: buttonRef,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      onPointerDown: onPointerDown,
      className: cx(handle, props.visible && "visible", isMoving && "isMoving"),
      "aria-describedby": descriptionId,
      "aria-label": "Juster h\xF8jden p\xE5 brik-omr\xE5det",
      children: /*#__PURE__*/jsx("span", {})
    }), /*#__PURE__*/jsx("span", {
      id: descriptionId,
      className: resets.screenReaderOnlyCls,
      "data-disable-polly": true,
      children: "Tryk Enter for at justere h\xF8jden p\xE5 brik-omr\xE5det"
    }), /*#__PURE__*/jsx("div", {
      id: liveContainerId,
      ref: liveContainerRef,
      "aria-live": "assertive",
      className: resets.screenReaderOnlyCls,
      "data-disable-polly": true
    })]
  });
}

export { DragHandle };
//# sourceMappingURL=atom.drag-handle.js.map
